import SETTINGS from "../globals";
import SearchCriteria from "../model/SearchCriteria";
import SearchCriteriaTools from "./SearchCriteriaTools";

class APIEndPoints {
  public static SIGNIN: string = "/signin";
  public static SIGNOUT: string = "/signout";
  public static SIGNINOTT(otc: string) {
    return "/signin/" + otc;
  }
  public static SIGNUP: string = "/register";
  public static USERS = {
    ALL: "/users?page=1&per_page=200",
    ONE: function (id: number) {
      return "/users/" + id;
    },
    SEARCH: function (search: string) {
      return `/users?search=${search}&per_page=5`;
    },
  };

  public static COUNTRIES = {
    ALL: "/countries?page=1&per_page=2000",
    PAGED: function (page: number, per_page: number): string {
      return `/countries?page=${page}&per_page=${per_page}`;
    },
    SEARCH: function (search: string): string {
      return `/countries?search=${search}&per_page=5`;
    },
    ONE: function (id: number) {
      return "/countries/" + id;
    },
  };

  public static PROVINCES = {
    SEARCH: function (search: string, country: string): string {
      return `/provinces?search=${search}&country=${country}&per_page=5`;
    },
    ONE: function (id: number) {
      return "/provinces/" + id;
    },
  };

  public static MUNICIPALITIES = {
    SEARCH: function (search: string, country: string, admin1: string): string {
      return `/municipalities?search=${search}&country=${country}&admin1=${admin1}&per_page=5`;
    },
    ONE: function (id: number) {
      return "/municipalities/" + id;
    },
  };

  public static SITES = {
    NEW: "/sites",
    ALL: "/sites?page=1&per_page=2000",
    PAGED: function (page: number, per_page: number, search?: string): string {
      return `/sites?page=${page}&per_page=${per_page}&search=${search}`;
    },
    ONE: function (id: number) {
      return "/sites/" + id;
    },
  };

  public static COLLECTIONS = {
    NEW: "/collections",
    ALL: "/collections?page=1&per_page=2000",
    PAGED: function (page: number, per_page: number, search?: string): string {
      return `/collections?page=${page}&per_page=${per_page}&search=${search}`;
    },
    ONE: function (id: number) {
      return "/collections/" + id;
    },
  };

  public static MY_LISTS = {
    NEW: "/mylist",
    ALL: "/mylist?page=1&per_page=2000",
    PAGED: function (page: number, per_page: number, search?: string): string {
      return `/mylist?page=${page}&per_page=${per_page}&search=${search}`;
    },
    ONE: function (id: number) {
      return "/mylist/" + id;
    },
  };

  public static PILOTS = {
    NEW: "/pilots",
    ALL: "/pilots?page=1&per_page=2000",
    PAGED: function (page: number, per_page: number, search?: string): string {
      return `/pilots?page=${page}&per_page=${per_page}&search=${search}`;
    },
    ONE: function (id: number) {
      return "/pilots/" + id;
    },
  };

  public static CHELEMENTS = {
    NEW: "/chelements",
    ALL: "/chelements",
    ONE: function (id: number) {
      return "/chelements/" + id;
    },
    SEARCH: function (criteria: SearchCriteria): string {
      //return `/chelements?page=${criteria.page}&per_page=${criteria.per_page}&search=${criteria.search}&sort=${criteria.sort}&order=${criteria.order}`;
      return `/chelements?${SearchCriteriaTools.searchCriteriaToQueryString(
        criteria,
      )}`;
    },
    BY_SITE: function (id_site: number): string {
      return `/sites/${id_site}/chelements?page=1&per_page=2000`;
    },
    PAGED_BY_SITE: function (
      page: number,
      per_page: number,
      id_site: number,
      search?: string,
    ): string {
      return `/sites/${id_site}/chelements?page=${page}&per_page=${per_page}&search=${search}`;
    },
  };

  public static E3DS = {
    NEW: function (id_chelement: number): string {
      return `/chelements/${id_chelement}/e3ds`;
    },
    ALL: function (id_chelement: number): string {
      return `/chelements/${id_chelement}/e3ds?page=1&per_page=2000`;
    },
    PAGED: function (
      page: number,
      per_page: number,
      id_chelement: number,
      search?: string,
    ): string {
      return `/chelements/${id_chelement}/e3ds?page=${page}&per_page=${per_page}&sort=reference_date&order=desc`;
    },
    ONE: function (id: number) {
      return "/e3ds/" + id;
    },
  };

  public static ANNEXDATA = {
    NEW: "/annexdata",
    ALL: function (
      id_chelement: number | undefined,
      id_site: number | undefined,
      id_e3dmodel: number | undefined,
    ): string {
      return id_chelement
        ? `/chelements/${id_chelement}/annexdata?page=1&per_page=2000`
        : id_site
          ? `/sites/${id_site}/annexdata?page=1&per_page=2000`
          : id_e3dmodel
            ? `/e3ds/${id_e3dmodel}/annexdata?page=1&per_page=2000`
            : "";
    },
    PAGED: function (
      page: number,
      per_page: number,
      id_chelement: number | undefined,
      id_site: number | undefined,
      search?: string,
    ): string {
      return id_chelement
        ? `/chelements/${id_chelement}/annexdata?page=${page}&per_page=${per_page}`
        : id_site
          ? `/sites/${id_site}/annexdata?page=${page}&per_page=${per_page}`
          : "";
    },
    ONE: function (id: number) {
      return "/annexdata/" + id;
    },
  };

  public static CONDITION_REPORTS = {
    NEW: function (id_e3ds: number): string {
      return `/e3ds/${id_e3ds}/conditionreports`;
    },
    ALL: function (id_e3ds: number): string {
      return `/e3ds/${id_e3ds}/conditionreports?page=1&per_page=2000`;
    },
    OFCHELEMENT: function (id_chelement: number): string {
      return `/chelements/${id_chelement}/conditionreports?page=1&per_page=2000`;
    },
    PAGED: function (
      page: number,
      per_page: number,
      id_e3ds: number,
      search?: string,
    ): string {
      return `/e3ds/${id_e3ds}/conditionreports?page=${page}&per_page=${per_page}`;
    },
    ONE: function (id: number) {
      return `/conditionreports/${id}`;
    },
  };

  public static _3DINSTANCES = {
    NEW: function (id_e3d: number): string {
      return `/e3ds/${id_e3d}/e3dinstances`;
    },
    ALL: function (id_e3d: number): string {
      return `/e3ds/${id_e3d}/e3dinstances?page=1&per_page=2000`;
    },
    ALLFROMDB: "/e3dinstances",
    PAGED: function (
      page: number,
      per_page: number,
      id_e3d: number,
      search?: string,
    ): string {
      return `/e3ds/${id_e3d}/e3dinstances?page=${page}&per_page=${per_page}`;
    },
    ONE: function (id: number) {
      return "/e3dinstances/" + id;
    },
  };

  public static TEXTURES = {
    NEW: function (id_3dinstance: number): string {
      return `/e3dinstances/${id_3dinstance}/textures`;
    },
    ALL: function (id_3dinstance: number): string {
      return `/e3dinstances/${id_3dinstance}/textures?page=1&per_page=2000`;
    },
    PAGED: function (
      page: number,
      per_page: number,
      id_3dinstance: number,
      search?: string,
    ): string {
      return `/e3dinstances/${id_3dinstance}/textures?page=${page}&per_page=${per_page}`;
    },
    ONE: function (id: number) {
      return "/textures/" + id;
    },
  };

  public static SPATIAL_RELATIONS = {
    NEW: function (id_sp_rel: number): string {
      return `/e3dinstances/${id_sp_rel}/spatialrelations`;
    },
    ALL: function (id_instance: number): string {
      return `/e3dinstances/${id_instance}/spatialrelations?page=1&per_page=2000`;
    },
    ONE: function (id: number) {
      return "/spatialrelations/" + id;
    },
  };

  public static ANNOTATIONS = {
    NEW: function (id_3dinstance: number): string {
      return `/e3dinstances/${id_3dinstance}/annotations`;
    },
    ALL: function (id_3dinstance: number): string {
      return `/e3dinstances/${id_3dinstance}/annotations?page=1&per_page=2000`;
    },
    PAGED: function (
      page: number,
      per_page: number,
      id_3dinstance: number,
      search?: string,
    ): string {
      return `/e3dinstances/${id_3dinstance}/annotations?page=${page}&per_page=${per_page}`;
    },
    ONE: function (id: number) {
      return "/annotations/" + id;
    },
    ALTERATION_EVENTS: function (id_annotation: number) {
      return `/annotations/${id_annotation}/alterationevents`;
    },
  };

  public static UPLOADS = {
    START: "/uploads",
    CHUNK: function (id_upload: number) {
      return `/uploads/${id_upload}/chunks`;
    },
    COMPLETE: function (id_upload: number) {
      return `/uploads/${id_upload}/complete`;
    },
  };

  public static DOWNLOADS = {
    FILE: function (id_upload: number | string) {
      return `${SETTINGS.API_ROOT}/downloads/${id_upload}`;
    },
    CODE: function (id_file: number): string {
      return `/generate_download_code/${id_file}`;
    },
  };

  public static pagedData(path: string, page: number, per_page: number) {
    return path;
  }

  public static CLIENTS = {
    NEW: "/clients",
    ALL: "/clients",
    ONE: function (id: number) {
      return "/clients/" + id;
    },
  };

  public static ALTERATION_FORMS = {
    NEW: "/alterationforms",
    ALL: "/alterationforms?page=1&per_page=200",
    PAGED: function (page: number, per_page: number): string {
      return `/alterationforms?page=${page}&per_page=${per_page}`;
    },
    ONE: function (id: number) {
      return "/alterationforms/" + id;
    },
  };

  public static ALTERATIONS = {
    NEW: "/alterations",
    ALL: "/alterations?page=1&per_page=200",
    PAGED: function (page: number, per_page: number): string {
      return `/alterations?page=${page}&per_page=${per_page}`;
    },
    ONE: function (id: number) {
      return "/alterations/" + id;
    },
  };

  public static MATERIALS = {
    NEW: "/materials",
    ALL: "/materials?page=1&per_page=200",
    PAGED: function (page: number, per_page: number): string {
      return `/materials?page=${page}&per_page=${per_page}`;
    },
    ONE: function (id: number) {
      return "/materials/" + id;
    },
  };

  public static CHUSAGES = {
    NEW: "/chusages",
    ALL: "/chusages?page=1&per_page=200",
    PAGED: function (page: number, per_page: number): string {
      return `/chusages?page=${page}&per_page=${per_page}`;
    },
    ONE: function (id: number) {
      return "/chusages/" + id;
    },
  };

  public static STATIC_PAGES = {
    NEW: "/static-pages",
    ALL: "/static-pages?page=1&per_page=200",
    PAGED: function (page: number, per_page: number): string {
      return `/static-pages?page=${page}&per_page=${per_page}`;
    },
    ONE: function (id: number) {
      return "/static-pages/" + id;
    },
    SEARCHED: function (code: string) {
      return "/static-pages/slug/" + code;
    },
  };

  public static INSPECTION_MODES = {
    ALL: "/inspectionmodes?page=1&per_page=200",
    PAGED: function (page: number, per_page: number): string {
      return `/chusages?page=${page}&per_page=${per_page}`;
    },
    ONE: function (id: number) {
      return "/inspectionmodes/" + id;
    },
  };

  public static SEARCH = {
    PAGED: function (criteria: SearchCriteria): string {
      return `/search?page=${criteria.page}&per_page=${criteria.per_page}&search=${criteria.search}&sort=${criteria.sort}&order=${criteria.order}`;
    },
  };

  public static RESEND_CONFIRMATION_EMAIL = {
    ONE: "/resend_confirmation",
  };

  public static GUIDS = {
    SEARCH: function (guid: String) {
      return "/guids/" + guid;
    },
  };

  public static EMAILS = {
    NEW: "/send_user_request",
  };

  public static OAUTH = {
    AUTHORIZE: "/oauth/authorize",
    TOKEN: "/oauth/token",
    LOGIN: "/login",
    SIGNIN: "/oauth/signin",
    LOGOUT: "/oauth/logout",
  };
}

export default APIEndPoints;
